import { useEffect } from "react";

import { Toast } from "../components/toast";

export const useQueryError = ({
  isError,
  error,
  message = "Ocurrió un error al obtener los datos.",
}) => {
  useEffect(() => {
    if (isError && error) {
      Toast("error", message, error.message);
    }
  }, [isError, error, message]);
};
